<div class="ui-g ui-fluid config-table">
  <div class="grid field col-12">
    <p-table #dt [columns]="measurementConfigurationCols" [value]="deviceMeasurementChannelConfigurations || []"
      [scrollable]="true" class="config-table" sortField="name">
      <ng-template #colgroup let-columns>
        <colgroup>
        @for (col of columns; track col) {
          <col [style.width]="col.width" />
        }
      </colgroup>
    </ng-template>
    <ng-template #header let-columns>
      <tr>
        @for (col of columns; track col) {
          <th>
            {{col.header}}
          </th>
        }
      </tr>
    </ng-template>
    <ng-template #body let-configuration let-index="rowIndex">
      @if (configuration) {
        <tr [pReorderableRow]="index">
          <td>
            <input type="text" pInputText placeholder="Enter Name" [(ngModel)]="configuration.measurementName"
              (ngModelChange)="measurementNameChanged(configuration)"/>
            </td>
            <td>
              <p-select [options]="wellKnownMeasurementOptions" placeholder="Select Known Measurement"
                [(ngModel)]="configuration.wellKnownMeasurementName" appendTo="body" (onChange)="wellKnownMeasurementChanged(configuration)"
              [style]="{'width':'100%'}"></p-select>
            </td>
            <td>
              <p-select [options]="measurementDataTypes" placeholder="Select Type" [(ngModel)]="configuration.measurementDataType"
              appendTo="body" (onChange)="measurementDataTypeChanged(configuration)" [style]="{'width':'100%'}"></p-select>
            </td>
            <td>
              <p-select [options]="getUnitSelectItems(configuration.wellKnownMeasurementName)" placeholder="Select Units"
                [disabled]="configuration.measurementDataType == 'Text'"
                [(ngModel)]="configuration.unitOfMeasurementId" appendTo="body" [style]="{'width':'100%'}"
              (onChange)="unitsChanged(configuration)"></p-select>
            </td>
            <td>
              <i class="fas fa-sort" style="margin-right:2px;" pReorderableRowHandle></i>
              <i class="far fa-trash-alt" (click)="confirmDeleteConfiguration(configuration)"></i></td>
            </tr>
          }
        </ng-template>
        <ng-template #summary>
          <button pButton type="button" (click)="addConfiguration()" class="add-button">
            <i pButtonIcon class="fa fa-plus"></i>
            <span pButtonLabel>Add Configuration</span>
          </button>
        </ng-template>
      </p-table>
    </div>
